import React from 'react';
import ProductCardBundleBox from './product-card-bundle-box';
import '../css/product-card-bundle.less';

const ProductCardBundle = ({ bundle }) => {
    return (
        <div className="prd-card-bundle">
            { bundle.map((prd) => (<ProductCardBundleBox sku={prd} key={prd} />)) }
        </div>
    )
}

export default ProductCardBundle;